import type { EmployerStatus } from '@duke-hq/shared-constants/employer';
import { StatusPill } from './StatusPill';
import { employerStatusColorScheme, employerStatusShortLabel } from './employerStatusDisplay';

export function EmployerStatusBadge({
  status,
  'data-testid': dataTestId,
}: {
  status: EmployerStatus;
  'data-testid'?: string;
}): React.ReactElement {
  return (
    <StatusPill
      label={employerStatusShortLabel(status)}
      colorScheme={employerStatusColorScheme(status)}
      data-testid={dataTestId}
    />
  );
}
